import _asyncToGenerator from "/usr/src/app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _regeneratorRuntime from "/usr/src/app/node_modules/@babel/runtime/regenerator/index.js";
// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.
import { blobToString } from "./utils/utils.browser";
export function getBodyAsText(_x) {
  return _getBodyAsText.apply(this, arguments);
}

function _getBodyAsText() {
  _getBodyAsText = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(batchResponse) {
    var blob;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return batchResponse.blobBody;

          case 2:
            blob = _context.sent;
            return _context.abrupt("return", blobToString(blob));

          case 4:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _getBodyAsText.apply(this, arguments);
}

export function utf8ByteLength(str) {
  return new Blob([str]).size;
}